<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <table class="govuk-table">
    <tbody class="govuk-table__body">
      <tr class="govuk-table__row">
        <td class="govuk-table__cell">
          <a href="#">Vzorová príloha.pdf</a>
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          <a href="#">Odstrániť</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss">
.dissabled {
  color: rgb(133, 133, 133);
}

td {
  white-space: pre-line;
}
</style>
